module.exports = __webpack_public_path__ + "static/media/корридор гг 2.de833b4b.jpg";